import rootReducer from '../reducers'
import createSagaMiddleware from 'redux-saga'
import rootSaga from '../sagas'
import { createStore, compose, applyMiddleware } from 'redux'
import { createOffline } from '@redux-offline/redux-offline'
import offlineConfig from '@redux-offline/redux-offline/lib/defaults'
import { persistStore, persistReducer } from 'redux-persist';
import localForage from 'localforage';
import logger from 'redux-logger'

const persistConfig = {
  key: 'root',
  storage: localForage
};

const {
  middleware: offlineMiddleware,
  enhanceReducer: offlineEnhanceReducer,
  enhanceStore: offlineEnhanceStore
} =  createOffline({
  ...offlineConfig,
  persist: false
});

const persistedReducer = persistReducer(
  persistConfig,
  offlineEnhanceReducer(rootReducer)
);

export default function configureStore (initialState) {
  const sagaMiddleware = createSagaMiddleware();
  // const rootReducer = combineReducers(reducers);
  const middlewareList = [
    /* other middleware here */
    sagaMiddleware,
    logger
  ];


const middleware = applyMiddleware(...middlewareList, offlineMiddleware);

const store = createStore(persistedReducer, compose(offlineEnhanceStore, middleware, window.devToolsExtension ? window.devToolsExtension() : f => f));
sagaMiddleware.run(rootSaga);
const persistor = persistStore(store);

return { persistor, store };
}



